import React from 'react';
import './contactUs.css';
import NavBar from '../../componets/navbar/navbar.js'
import { Container, Row, Col, Form, Button } from 'react-bootstrap'
import MapContainer from '../../componets/mapContainer/mapContainer'
import sendMail from '../../utils/email';
import { getContactContent } from '../../services/contentService';


class ContactUs extends React.Component {
    constructor(props) {
      super(props);
            this.state = {
                email: 'rawslcontact@gmail.com',
                address: 'Unit 2F-3, 265/115, Torrington Avenue, Colombo 05.',
                mobileNumbers: ['+94 77 368 5371', '+94 77 369 8374']
            };
      // To use the 'this' keyword, we need to bind it to our function
    }

        async componentDidMount() {
            try {
                const contact = await getContactContent();
                const mobileNumbers = (contact.mobileNumbers || []).map((number) =>
                    number.startsWith('+94') ? number : `+94 ${number.replace(/^0/, '').replace(/(\d{2})(\d{3})(\d{4})/, '$1 $2 $3')}`
                );

                this.setState({
                    email: contact.email || this.state.email,
                    address: contact.address || this.state.address,
                    mobileNumbers: mobileNumbers.length ? mobileNumbers : this.state.mobileNumbers
                });
            } catch (_) {
                // Keep defaults if manifest is unavailable.
            }
        }

    handleSubmit(event){
        event.preventDefault();
        const form = event.target;
        const name = form.elements.name.value;
        const mail = form.elements.mail.value;
        const subject = form.elements.subject.value;
        const message = form.elements.message.value;
        if ( !name || !mail || !subject || !message){
            window.alert('Please fill out the full form.');
        }
        else{
            sendMail(name, mail, subject, message);
        }
    }
    render(){ 
        return (
            <div>
                
                <div className="contact">
                <NavBar/>
                <Container fluid>
                <Row className='contact-us-details-row'>
                    <Col sm={8} className="bootstrap-col">
                        <Row className="contact-us-title">
                            Visit Us
                        </Row>
                        <Row className="bootstrap-row">
                            <Col sm ={3} className="bootstrap-col">
                                <Row className="contact-us-visit-details">
                                <strong>{this.state.address}</strong>
                                </Row>
                                <Row className="contact-us-mobile-details">
                                    <Col sm={2} className="bootstrap-col">
                                    <img
                                    src="/mobile.png"
                                    width="25"
                                    height="25"
                                    alt="React Bootstrap logo"
                                />
                                    </Col>
                                    <Col>
                                    {this.state.mobileNumbers.map((number) => (
                                      <Row key={number}>{number}</Row>
                                    ))}
                                    </Col>
                                    
                                </Row>
                                <Row className="contact-us-mail-details">
                                    <Col sm={2} className="bootstrap-col">
                                    <img
                                    src="/email.png"
                                    width="25"
                                    height="25"
                                    alt="React Bootstrap logo"
                                />
                                    </Col>
                                    <Col>
                                    <Row><p><strong> {this.state.email}</strong></p></Row>
                                    </Col>
                                    
                                </Row>
                                <Row className="contact-us-visit-details-image">
                                <div className="image-container">
                                <img
                                    src="/facebook.png"
                                    width="50"
                                    height="50"
                                    alt="React Bootstrap logo"
                                    onClick={()=>{window.location.assign('https://www.facebook.com/robustarchitectureworkshop/')}}
                                />
                                <img
                                    src="/insta.png"
                                    width="53"
                                    height="40"
                                    alt="React Bootstrap logo"
                                    onClick={()=>{window.location.assign('https://www.instagram.com/robust_architecture_workshop/?hl=en')}}
                                />
                                </div>

                                </Row>
                            </Col>
                            <Col className="contact-us-map">
                            <Row>

                            <MapContainer/>
                            </Row>

                            </Col>
                        </Row>

                        

                    </Col>
                    <Col className="bootstrap-col">
                        <Row className="contact-us-title-email">
                            Email Us
                        </Row>
                        <Row className='email'>
                        <Form fluid className="form" onSubmit={this.handleSubmit.bind(this)}>
                            <Form.Group className="first-form-group" controlId="name">
                                <Form.Label>Name *</Form.Label>
                                <Form.Control placeholder="Enter Name" />
                            </Form.Group>
                            <Form.Group controlId="mail">
                                <Form.Label>Mail Address *</Form.Label>
                                <Form.Control type="email" placeholder="Enter your mail address" />
                            </Form.Group>
                            <Form.Group controlId="subject">
                                <Form.Label>Subject *</Form.Label>
                                <Form.Control placeholder="Enter Subject" />
                            </Form.Group>
                            <Form.Group controlId="message">
                                <Form.Label>Message *</Form.Label>
                                <Form.Control as="textarea" rows="5" placeholder="Enter Message" />
                            </Form.Group>
                            <Button variant="outline-dark" type="submit">
                                Submit
                            </Button>
                            </Form>
                        </Row>
                    </Col>
                    </Row>
                </Container>
                </div>
            </div>
        )
    }

}

export default ContactUs;